import {BaseApi} from '@/common/api/BaseApi';
import {ApiVersionProperties} from '@/types/common/api/api.types';

// T00VOQ5DCZSJ — checkout of the coach's own contract (coaching-api /checkout).
export class CheckoutApi {
  public static api({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/checkout`;
  }

  public static subdomain({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${CheckoutApi.api({version})}/subdomain`;
  }

  public static preview({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${CheckoutApi.api({version})}/preview`;
  }

  public static order({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${CheckoutApi.api({version})}/order`;
  }

  public static mandateStart({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${CheckoutApi.api({version})}/mandate/start`;
  }

  public static mandateComplete({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${CheckoutApi.api({version})}/mandate/complete`;
  }

  public static status({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${CheckoutApi.api({version})}/status`;
  }
}
